<template>
    <div>
        <MercenaryHeader :title="'알림'" :back-title="'활동 및 설정'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex:1; padding:0px 12px; padding-top:20px; background-color: #f5f5f5;">
            <div class="title">알림</div>
            <div class="alarm_container">
                <div style="flex:1;">
                    <div class="alarm_container_title">모든 푸시 알림 받지 않기</div>
                    <div class="alarm_container_explanation">모든 알림 수신이 중단됩니다</div>
                </div>
                <div style="display:grid; place-items: center;">
                    <CustomSwitchFilter v-model="settings.all_alarm" style="" :click-action="() => { saveSettings('all_alarm') }" :isBold="true" />
                </div>
            </div>

            <div class="title" style="margin-top:20px;">알림</div>
            <div class="container" @click="() => { is_open_account_alarm = true }">
                <div class="container_title">피드 및 모든 활동 알림</div>
                <div class="horizontal_line"></div>
                <div class="container_btn">설정하기</div>
            </div>

            <div class="title" style="margin-top:20px;">시스템 및 혜택</div>
            <div class="container" @click="() => { is_open_news_alarm = true }">
                <div class="container_title">소식 및 시스템 알림</div>
                <div class="horizontal_line"></div>
                <div class="container_btn">설정하기</div>
            </div>
            <div class="container" style="margin-top:10px;" @click="() => { is_open_event_alarm = true; }">
                <div class="container_title">이벤트 및 혜택 알림</div>
                <div class="horizontal_line"></div>
                <div class="container_btn">설정하기</div>
            </div>
        </div>

        <CommonPopupFrame :changeHeight="600" :change-height-unit="'px'" :changeBottom="0" :isOpen="is_open_account_alarm" :closeCompleteAction="() => { is_open_account_alarm = false }">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div style="padding:10px 20px;color:#808080; font-size:16px; font-weight:bold;" @click="() => { is_open_account_alarm = false }">닫기</div>
            <div style="flex: 1; overflow-y: scroll; padding: 12px; " @touchmove.stop="() => { }">
                <div style="padding:30px 0px;">
                    <div style="text-align:center; font-size:32px; font-weight:bold; color:#210F03;">피드 및 모든 활동</div>
                    <div style="text-align:center; font-size:16px; color:#210F03; margin-top:20px;">알람 받으실 활동 범위를 선택할 수 있습니다.</div>
                </div>

                <div class="title">피드의 모든 알림</div>
                <div class="alarm_container alarm_container_color1">
                    <div style="flex:1;">
                        <div class="alarm_container_title">슈팅 알림 받기</div>
                        <div class="alarm_container_explanation" style="">내가 만든 피드가 슈팅을 받으면 알림을 받습니다.</div>
                    </div>
                    <div class="switch_wrap" style="display:grid; place-items: center;">
                        <CustomSwitchFilter v-model="settings.soccerhow_like" style="" :click-action="() => { saveSettings('soccerhow_like') }" :isBold="true" />
                    </div>
                </div>

                <div class="alarm_container alarm_container_color1">
                    <div style="flex:1;">
                        <div class="alarm_container_title">댓글 및 답변 알림 받기</div>
                        <div class="alarm_container_explanation" style="">내가 만든 피드에 댓글 및 답변이 달리면 알림을 받습니다.</div>
                    </div>
                    <div class="switch_wrap" style="display:grid; place-items: center;">
                        <CustomSwitchFilter v-model="settings.soccerhow_answer_reply" style="" :click-action="() => { saveSettings('soccerhow_answer_reply') }" :isBold="true" />
                    </div>
                </div>

                <div class="alarm_container alarm_container_color1">
                    <div style="flex:1;">
                        <div class="alarm_container_title">인기게시물 알림 받기</div>
                        <div class="alarm_container_explanation" style="">내가 만든 피드가 인기게시물이 되면 알림을 받습니다.</div>
                    </div>
                    <div class="switch_wrap" style="display:grid; place-items: center;">
                        <CustomSwitchFilter v-model="settings.soccerhow_popular" style="" :click-action="() => { saveSettings('soccerhow_popular') }" :isBold="true" />
                    </div>
                </div>

                <div class="title" style="margin-top:20px;">멤버톡 및 메세지</div>
                <div class="alarm_container alarm_container_color1">
                    <div style="flex:1;">
                        <div class="alarm_container_title">멤버톡 / 메시지 알림 받기</div>
                        <div class="alarm_container_explanation" style="">내가 참여하고 있는 멤버톡 및 개인 메시지와 오픈멤버톡의 모든 대화에 대한 알림을 받습니다.</div>
                    </div>
                    <div class="switch_wrap" style="display:grid; place-items: center;">
                        <CustomSwitchFilter v-model="settings.member_talk_message" style="" :click-action="() => { saveSettings('member_talk_message') }" :isBold="true" />
                    </div>
                </div>

                <!--<div class="alarm_container alarm_container_color1">-->
                    <!--<div style="flex:1;">-->
                        <!--<div class="alarm_container_title">오픈멤버톡 알림받기</div>-->
                        <!--<div class="alarm_container_explanation" style="">내 활동지역의 오픈멤버톡 메시지를 알림 받습니다.</div>-->
                    <!--</div>-->
                    <!--<div class="switch_wrap" style="display:grid; place-items: center;">-->
                        <!--<CustomSwitchFilter v-model="settings.open_member_talk" style="" :click-action="() => { saveSettings('open_member_talk') }" :isBold="true" />-->
                    <!--</div>-->
                <!--</div>-->

                <!--<div class="alarm_container alarm_container_color1">-->
                    <!--<div style="flex:1;">-->
                        <!--<div class="alarm_container_title">초대 및 공유 알림 받기</div>-->
                        <!--<div class="alarm_container_explanation" style="">스케줄 초대 및 스케줄 공유 시 메시지를 알림받습니다.</div>-->
                    <!--</div>-->
                    <!--<div class="switch_wrap" style="display:grid; place-items: center;">-->
                        <!--<CustomSwitchFilter v-model="settings.schedule_invitation_alarm" style="" :click-action="() => { saveSettings('schedule_invitation_alarm') }" :isBold="true" />-->
                    <!--</div>-->
                <!--</div>-->

                <!--<div class="alarm_container alarm_container_color1">-->
                    <!--<div style="flex:1;">-->
                        <!--<div class="alarm_container_title">스쿼드 / 공지사항 / 스케줄 알림받기</div>-->
                        <!--<div class="alarm_container_explanation" style="">멤버톡에서 스쿼드 및 공지사항, 스케줄이 생성될 경우 알림을 받습니다.</div>-->
                    <!--</div>-->
                    <!--<div class="switch_wrap" style="display:grid; place-items: center;">-->
                        <!--<CustomSwitchFilter v-model="settings.member_talk_info" style="" :click-action="() => { saveSettings('member_talk_info') }" :isBold="true" />-->
                    <!--</div>-->
                <!--</div>-->

                <!--<div class="alarm_container alarm_container_color1">-->
                    <!--<div style="flex:1;">-->
                        <!--<div class="alarm_container_title">멤버톡 설정 변경 시 알림 받기</div>-->
                        <!--<div class="alarm_container_explanation" style="">멤버톡 세부 설정 변경 시 알림을 받습니다.</div>-->
                    <!--</div>-->
                    <!--<div class="switch_wrap" style="display:grid; place-items: center;">-->
                        <!--<CustomSwitchFilter v-model="settings.member_talk_change" style="" :click-action="() => { saveSettings('member_talk_change') }" :isBold="true" />-->
                    <!--</div>-->
                <!--</div>-->

                <!--<div class="title" style="margin-top:20px;">스케줄</div>-->
                <!--<div class="alarm_container alarm_container_color1">-->
                    <!--<div style="flex:1;">-->
                        <!--<div class="alarm_container_title">새로운 멤버 알림 받기</div>-->
                        <!--<div class="alarm_container_explanation" style="">내가 만들었거나 참여하는 스케줄에 새로운 멤버가 들어오면 알림을 받습니다.</div>-->
                    <!--</div>-->
                    <!--<div class="switch_wrap" style="display:grid; place-items: center;">-->
                        <!--<CustomSwitchFilter v-model="settings.schedule_new_member" style="" :click-action="() => { saveSettings('schedule_new_member') }" :isBold="true" />-->
                    <!--</div>-->
                <!--</div>-->

                <!--<div class="alarm_container alarm_container_color1">-->
                    <!--<div style="flex:1;">-->
                        <!--<div class="alarm_container_title">스케줄 시작 및 종료 알림 받기</div>-->
                        <!--<div class="alarm_container_explanation" style="">스케줄이 시작하기 하루 전과 종료 직후 스케줄 시작 및 종료 알림을 받습니다.</div>-->
                    <!--</div>-->
                    <!--<div class="switch_wrap" style="display:grid; place-items: center;">-->
                        <!--<CustomSwitchFilter v-model="settings.schedule_begin_end" style="" :click-action="() => { saveSettings('schedule_begin_end') }" :isBold="true" />-->
                    <!--</div>-->
                <!--</div>-->

                <!--<div class="alarm_container alarm_container_color1">-->
                    <!--<div style="flex:1;">-->
                        <!--<div class="alarm_container_title">스케줄 공유 알림 받기</div>-->
                        <!--<div class="alarm_container_explanation" style="">다른 회원에 의해 스케줄이 공유되었거나 스케줄에 초대외었을 경우 다음과 같은 알림을 받습니다.</div>-->
                        <!--<div class="alarm_container_explanation_sub">'soccerhow님이 스케줄을 공유 (혹은 초대)했습니다.'</div>-->
                    <!--</div>-->
                    <!--<div class="switch_wrap" style="display:grid; place-items: center;">-->
                        <!--<CustomSwitchFilter v-model="settings.schedule_share" style="" :click-action="() => { saveSettings('schedule_share') }" :isBold="true" />-->
                    <!--</div>-->
                <!--</div>-->

                <!--<div class="alarm_container alarm_container_color1">-->
                    <!--<div style="flex:1;">-->
                        <!--<div class="alarm_container_title">활동지역 스케줄 알림 받기</div>-->
                        <!--<div class="alarm_container_explanation" style="">내 활동지역에서 진행되는 스케줄을 알림 받습니다.</div>-->
                        <!--<div class="alarm_container_explanation_sub">'회원님이 활동중인 서울월드컵경기장에서 2개의 스케줄이 진행됩니다.'</div>-->
                    <!--</div>-->
                    <!--<div class="switch_wrap" style="display:grid; place-items: center;">-->
                        <!--<CustomSwitchFilter v-model="settings.schedule_new_region" style="" :click-action="() => { saveSettings('schedule_new_region') }" :isBold="true" />-->
                    <!--</div>-->
                <!--</div>-->

                <div class="title" style="margin-top:20px;">활동 인사이트</div>
                <div class="alarm_container alarm_container_color1">
                    <div style="flex:1;">
                        <div class="alarm_container_title">만보기 알림 받기</div>
                        <div class="alarm_container_explanation" style="">걸음 수로 전반 / 후반 / 풀타임에 알림을 받습니다.</div>
                    </div>
                    <div class="switch_wrap" style="display:grid; place-items: center;">
                        <CustomSwitchFilter v-model="settings.pedometer" style="" :click-action="() => { saveSettings('pedometer') }" :isBold="true" />
                    </div>
                </div>

                <!--<div class="alarm_container alarm_container_color1">-->
                    <!--<div style="flex:1;">-->
                        <!--<div class="alarm_container_title">만보기 알림 받기</div>-->
                        <!--<div class="alarm_container_explanation" style="">리더보드에 대한 알림을 받습니다.</div>-->
                    <!--</div>-->
                    <!--<div class="switch_wrap" style="display:grid; place-items: center;">-->
                        <!--<CustomSwitchFilter v-model="settings.reader_board" style="" :click-action="() => { saveSettings('reader_board') }" :isBold="true" />-->
                    <!--</div>-->
                <!--</div>-->

                <div style="height:30px;"></div>
            </div>
        </CommonPopupFrame>

        <CommonPopupFrame :changeHeight="600" :change-height-unit="'px'" :changeBottom="0" :isOpen="is_open_news_alarm" :closeCompleteAction="() => { is_open_news_alarm = false }">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div style="padding:10px 20px;color:#808080; font-size:16px; font-weight:bold;" @click="() => { is_open_news_alarm = false }">닫기</div>
            <div style="flex: 1; overflow-y: scroll; padding: 12px; " @touchmove.stop="() => { }">
                <div style="padding:30px 0px;">
                    <div style="text-align:center; font-size:32px; font-weight:bold; color:#210F03;">피드 및 모든 활동</div>
                    <div style="text-align:center; font-size:16px; color:#210F03; margin-top:20px;">알람 받으실 활동 범위를 선택할 수 있습니다.</div>
                </div>

                <div class="alarm_container alarm_container_color1">
                    <div style="flex:1;">
                        <div class="alarm_container_title">사커하우 소식 알림 받기</div>
                        <div class="alarm_container_explanation" style="">사커하우 공지사항이 등록되면 알림을 받습니다.</div>
                    </div>
                    <div class="switch_wrap" style="display:grid; place-items: center;">
                        <CustomSwitchFilter v-model="settings.system_news" style="" :click-action="() => { saveSettings('system_news') }" :isBold="true" />
                    </div>
                </div>

                <div class="alarm_container alarm_container_color1">
                    <div style="flex:1;">
                        <div class="alarm_container_title">고객지원 메시지 알림 받기</div>
                        <div class="alarm_container_explanation" style="">사커하우 고객지원 메시지 알림을 받습니다.</div>
                    </div>
                    <div class="switch_wrap" style="display:grid; place-items: center;">
                        <CustomSwitchFilter v-model="settings.cs_message" style="" :click-action="() => { saveSettings('cs_message') }" :isBold="true" />
                    </div>
                </div>

                <div class="alarm_container alarm_container_color1">
                    <div style="flex:1;">
                        <div class="alarm_container_title">신고 후 피드백 알림 받기</div>
                        <div class="alarm_container_explanation" style="">피드 혹은 프로필을 신고했을 경우 신고 피드백을 알림 받습니다.</div>
                        <div class="alarm_container_explanation_sub">'신고한 게시물 혹은 프로필에 대한 조치가 이루어졌습니다.’</div>
                    </div>
                    <div class="switch_wrap" style="display:grid; place-items: center;">
                        <CustomSwitchFilter v-model="settings.report_feedback" style="" :click-action="() => { saveSettings('report_feedback') }" :isBold="true" />
                    </div>
                </div>

            </div>
        </CommonPopupFrame>


        <CommonPopupFrame :changeHeight="600" :change-height-unit="'px'" :changeBottom="0" :isOpen="is_open_event_alarm" :closeCompleteAction="() => { is_open_event_alarm = false }">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div style="padding:10px 20px;color:#808080; font-size:16px; font-weight:bold;" @click="() => { is_open_event_alarm = false }">닫기</div>
            <div style="flex: 1; overflow-y: scroll; padding: 12px; " @touchmove.stop="() => { }">
                <div style="padding:30px 0px;">
                    <div style="text-align:center; font-size:32px; font-weight:bold; color:#210F03;">피드 및 모든 활동</div>
                    <div style="text-align:center; font-size:16px; color:#210F03; margin-top:20px;">알람 받으실 활동 범위를 선택할 수 있습니다.</div>
                </div>

                <div class="alarm_container alarm_container_color1">
                    <div style="flex:1;">
                        <div class="alarm_container_title">홍보성 알림 받기</div>
                        <div class="alarm_container_explanation" style="">마케팅 알림을 받습니다.</div>
                    </div>
                    <div class="switch_wrap" style="display:grid; place-items: center;">
                        <CustomSwitchFilter v-model="settings.event_ad" style="" :click-action="() => { saveSettings('event_ad') }" :isBold="true" />
                    </div>
                </div>

                <div class="alarm_container alarm_container_color1">
                    <div style="flex:1;">
                        <div class="alarm_container_title">혜택성 알림 받기</div>
                        <div class="alarm_container_explanation" style="">쿠폰 제공, 포인트 적립, 응모 이벤트 등의 알림을 받습니다.</div>
                    </div>
                    <div class="switch_wrap" style="display:grid; place-items: center;">
                        <CustomSwitchFilter v-model="settings.event_benefit" style="" :click-action="() => { saveSettings('event_benefit') }" :isBold="true" />
                    </div>
                </div>

            </div>
        </CommonPopupFrame>

    </div>
</template>

<script>
import MercenaryHeader from "../../common/MercenaryHeader";
import CustomSwitchFilter from "../../common/CustomSwitchFilter";
import CommonPopupFrame from "./CommonPopupFrame";
import ResponseCode from "../../../ResponseCode";
export default {
    name: "AlarmManage",
    components: { CommonPopupFrame, CustomSwitchFilter, MercenaryHeader },
    data() {
        return {
            settings: {
                event_benefit: false,
                event_ad: false,
                system_news: false,
                soccerhow_popular: false,
                soccerhow_answer_reply: false,
                soccerhow_like: false,
                interest_feed: false,
                member_talk_message: false,
                open_member_talk: false,
                schedule_invitation_alarm: false,
                member_talk_info: false,
                member_talk_change: false,
                schedule_new_member: false,
                schedule_begin_end: false,
                schedule_share: false,
                schedule_new_region: false,
                pedometer: false,
                reader_board: false,
                cs_message: false,
                report_feedback: false,
                member_talk_invitation: false,
                schedule_invitation: false,
                profile_hidden: false,
                all_alarm: false,
            },
            is_open_account_alarm: false,
            is_open_news_alarm: false,
            is_open_event_alarm: false,
        }
    },
    methods: {
        async getSettings() {
            const parameters = {};
            const res = await this.$Axios.get('/api/setting/mine', { params: parameters });

            const settings = {}

            for (const each in res.data.setting) {
                settings[each] = res.data.setting[each] == '1'
            }

            console.log(settings);
            this.settings = settings;

        },
        async saveSettings(key) {
            setTimeout(async () => {
                const parameters = {};
                parameters[key] = this.settings[key] ? '1' : '0';
                const res = await this.$Axios.post('/api/setting/save', parameters);
                if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }, 50);

        }
    },
    created() {
        this.getSettings();
    }
}
</script>

<style scoped>
.title {
    color: #210F03;
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: 500;
}

.alarm_container {
    background-color: white;
    border-radius: 12px;
    padding: 15px 12px;
    display: flex;
}

.horizontal_line {
    height: 1px;
    background-color: #EBEBEB;
    margin: 10px 0px;
}

.container {
    background-color: white;
    border-radius: 12px;
    padding: 15px 12px;
}

.container_title {
    color: #210F03;
    font-size: 14px;
    font-weight: 500;
}

.container_btn {
    color: var(--color-main);
    font-size: 14px;
    font-weight: 500;
}

.alarm_container_color1 {
    background-color: #F5F5F5;
}

.alarm_container_title {
    font-size: 14px;
    color: #210f03;
    font-weight: bold;
}

.alarm_container_explanation {
    font-size: 12px;
    color: #210f03;
    margin-top: 5px;
    line-height: 18px;
}

.alarm_container+.alarm_container {
    margin-top: 10px;
}

.alarm_container_explanation_sub {
    color: #808080;
    font-size: 12px;
    line-height: 18px;
}

.switch_wrap {
    padding-left: 10px;
}
</style>